import BaseModel from "../base/BaseModel.model";
export default class DocoralCommittee extends BaseModel {
  public evaluatedStudent?: string;
  public institution?: string;
  public titleProposal?: string;
  public starYear?: Date | any;
  public endYear?:  Date | any;
  constructor() {
    super();
    this.init();
  }

  init() {
    this.evaluatedStudent = "";
    this.institution = "";
    this.titleProposal = "";
  }
}
